import { DialogRef, DIALOG_DATA } from '@angular/cdk/dialog';
import { Component, inject, model, ChangeDetectionStrategy } from '@angular/core';
import { BaseDialogComponent, DialogHeaderComponent } from '@cumlaude/shared-components-dialogs';
import { ButtonComponent } from '@cumlaude/shared-components-buttons';
import { FormsModule } from '@angular/forms';
import { AutofocusDirective } from '@cumlaude/shared-components-inputs';

@Component({
	selector: 'app-chat-feedback',
	templateUrl: './chat-feedback.component.html',
	styleUrls: ['./chat-feedback.component.scss'],
	imports: [BaseDialogComponent, DialogHeaderComponent, ButtonComponent, FormsModule, AutofocusDirective],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ChatFeedbackComponent {
	dialogRef = inject<DialogRef<string>>(DialogRef);

	data = inject<{ sentiment?: 1 | -1; feedback?: string } | null>(DIALOG_DATA, { optional: true });

	feedback = model<string>(this.data?.feedback ?? '');

	keyDown(event: KeyboardEvent) {
		if (event.key === 'Enter' && !event.shiftKey) {
			this.dialogRef.close(this.feedback());
			event.preventDefault();
		} else if (event.key === 'Escape') {
			this.dialogRef.close();
			event.preventDefault();
		}
	}
}
